import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  margin: 40px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  min-height: 246px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material";
import { Container } from "@/components/Container";
import { CouponFilterSection } from "@/components/Coupons/GetCoupons/CouponFilterSection";
import { CouponListSection } from "@/components/Coupons/GetCoupons/CouponListSection";
import { useQuery } from "@tanstack/react-query";
import { getCouponFilters, getReceivableCoupons } from "../../api/coupon";
import useCouponFilter from "@/components/Coupons/GetCoupons/useCouponFilter";
import { getUserMeta } from "src/api/users";
import { useAuthStore } from "@/lib/auth/AuthStore";
const CouponPage = (param)=>{
    let {} = param;
    const { isLoggedIn , user  } = useAuthStore();
    const { handleCategory , handleSubject , category , subject  } = useCouponFilter();
    const { data: getCouponFilterResponse  } = useQuery([
        "couponFilter"
    ], getCouponFilters, {
        onError: (error)=>{
            ;
        },
        onSuccess: (data)=>{
            ;
        }
    });
    const { data: userMetaResponse  } = useQuery([
        user
    ], getUserMeta, {
        onError: (error)=>{
            ;
        },
        enabled: isLoggedIn
    });
    //유저의 선택과목
    const renderSubject = useMemo(()=>{
        var _getCouponFilterResponse_subjectItems_;
        if (subject) return subject;
        if (isLoggedIn && (userMetaResponse === null || userMetaResponse === void 0 ? void 0 : userMetaResponse.mainSubject)) return userMetaResponse.mainSubject;
        return (_getCouponFilterResponse_subjectItems_ = getCouponFilterResponse === null || getCouponFilterResponse === void 0 ? void 0 : getCouponFilterResponse.subjectItems[0]) === null || _getCouponFilterResponse_subjectItems_ === void 0 ? void 0 : _getCouponFilterResponse_subjectItems_.id;
    }, [
        subject,
        getCouponFilterResponse,
        userMetaResponse
    ]);
    //subject의 가장 첫번째 값으로 초기화
    const renderCategory = useMemo(()=>{
        var _getCouponFilterResponse_subjectItems_filter__categoryItems_, _getCouponFilterResponse_subjectItems_filter_;
        return category || ((_getCouponFilterResponse_subjectItems_filter__categoryItems_ = (_getCouponFilterResponse_subjectItems_filter_ = getCouponFilterResponse === null || getCouponFilterResponse === void 0 ? void 0 : getCouponFilterResponse.subjectItems.filter((item)=>item.id === renderSubject)[0]) === null || _getCouponFilterResponse_subjectItems_filter_ === void 0 ? void 0 : _getCouponFilterResponse_subjectItems_filter_.categoryItems[0]) === null || _getCouponFilterResponse_subjectItems_filter__categoryItems_ === void 0 ? void 0 : _getCouponFilterResponse_subjectItems_filter__categoryItems_.title);
    }, [
        category,
        subject,
        getCouponFilterResponse
    ]);
    const { data: getRecievableCouponResponse  } = useQuery([
        "receivableCouponList",
        category,
        renderSubject
    ], ()=>getReceivableCoupons({
            subject: renderSubject,
            category: renderCategory
        }), {
        onError: (error)=>{
            ;
        },
        enabled: !!getCouponFilterResponse
    });
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs(CouponPageContainer, {
            children: [
                /*#__PURE__*/ _jsx(Header, {
                    children: "할인쿠폰 받기"
                }),
                getCouponFilterResponse && /*#__PURE__*/ _jsx(CouponFilterSection, {
                    subject: renderSubject,
                    category: renderCategory,
                    handleCategory: handleCategory,
                    handleSubject: handleSubject,
                    filterList: getCouponFilterResponse.subjectItems
                }),
                getRecievableCouponResponse ? /*#__PURE__*/ _jsx(CouponListSection, {
                    data: getRecievableCouponResponse,
                    category: renderCategory
                }) : /*#__PURE__*/ _jsx(LoadingContainer, {})
            ]
        })
    });
};
export default CouponPage;
const CouponPageContainer = styled.div.withConfig({
    componentId: "sc-c43793ad-0"
})(_templateObject());
const Header = muiStyled("h3")((param)=>{
    let { theme  } = param;
    return {
        ...theme.typography.bold24
    };
});
const LoadingContainer = styled.div.withConfig({
    componentId: "sc-c43793ad-1"
})(_templateObject1());
